module.exports = __webpack_public_path__ + "img/知识星球分享二维码.dff3e122.jpg";